var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNaverIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.57422 0.324156C2.07031 0.144469 2.625 0.296812 2.96094 0.699156L13.25 13.0468V1.49994C13.25 0.808531 13.8086 0.249937 14.5 0.249937C15.1914 0.249937 15.75 0.808531 15.75 1.49994V16.4999C15.75 17.0273 15.4219 17.496 14.9258 17.6757C14.4297 17.8554 13.875 17.7031 13.5391 17.3007L3.25 4.95306V16.4999C3.25 17.1913 2.69141 17.7499 2 17.7499C1.30859 17.7499 0.75 17.1913 0.75 16.4999V1.49994C0.75 0.972594 1.07813 0.503844 1.57422 0.324156Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNaverIcon);
export default __webpack_public_path__ + "static/media/naver_icon.5dfb47daa0160d57c0958f985bd0a937.svg";
export { ForwardRef as ReactComponent };